export class PlantDto {
    plantId: number;
    plantCode: string;
    plantName: string;
    isActive: boolean;
    createdAt?: Date;
    createdUser?: string;
    updatedAt?: Date;
    updatedUser?: string;
    versionFlag?: number;
  
    constructor(
      plantId: number,
      plantCode: string,
      plantName: string,
      isActive: boolean,
      createdAt?: Date,
      createdUser?: string,
      updatedAt?: Date,
      updatedUser?: string,
      versionFlag?: number
    ) {
      this.plantId = plantId;
      this.plantCode = plantCode;
      this.plantName = plantName;
      this.isActive = isActive;
      this.createdAt = createdAt;
      this.createdUser = createdUser;
      this.updatedAt = updatedAt;
      this.updatedUser = updatedUser;
      this.versionFlag = versionFlag;
    }
  }
  